module.exports = __webpack_public_path__ + "assets/img/file1.951c9118.png";